@import "~animatewithsass/animate.scss";

@mixin delete-button {
  margin-top: 4px;
  margin-right: 5px;
  font-size: 14px;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  background-color: #ff0048;
  color: white;
  padding: 6px;
  border-radius: 6px;
  display: inline-block;
  cursor: pointer;
}

@mixin minus-button {
  outline: none !important;
  background-color: #FF0048;
  -webkit-text-stroke: 1px #FF0048;
  width: 20px;
  height: 20px;
  padding: 0;
  padding-top: 1px;
  font-size: 11px !important;
  margin-right: 5px;
  color: white;
  border-radius: 100%;
  transition: transform 0.5s ease;
}

@mixin header {
  @media (max-width: 767px) {
    padding-top: 12px !important;
  }
  font-size: 25px;
  @media (min-width: 768px) and (max-width: 1100px) {
    font-size: 22px;
  }
  font-weight: lighter;
  letter-spacing: 1px;
  .fa-info-circle {
    font-size: 15px;
    @media (min-width: 768px) and (max-width: 1100px) {
    }
    margin-left: 7px;
    margin-right: 10px;
    position: relative;
    bottom: 2px;
    cursor: pointer;
  }

  .delete-control-vertical-false {
    @include minus-button;
    transform: rotate(0deg);
  }

  .minus-horizontal {
    @include minus-button;
    transform: rotate(0deg);
  }

  .delete-control-vertical-true {
    @include minus-button;
    transform: rotate(-90deg);
  }

  .minus-vertical {
    @include minus-button;
    transform: rotate(-90deg);
  }

  .delete {
    display: inline-block;
  }

  .delete-button-true {
    @include delete-button;
    max-width: 200px;
    transition: max-width .5s;
  }

  .delete-button-false {
    @include delete-button;
    visibility: hidden;
    padding-left: 0;
    max-width: 0;
    transition: max-width .5s, visibility 0.4s, padding-left 1s;
  }
}

.header {
  @include header;
}

// styles for divider starts here

.box {
  border-radius: 10px;
  .vertical-divider {
    width: 5px;
    margin: 0 auto;
    height: 100%;
  }
}

// Styles for divider ends here

@media (min-width: 768px) and (max-width: 1100px) {
  .col-md-1 {
    float: left;
    width: 5.333333% !important;
  }
  .col-md-10 {
    float: left;
    width: 100% !important;
  }

  button {
    font-size: 12px !important;
  }

  .drinks-row-block1 {
    padding: 0 !important;
    .col-md-custom {
      div {
        font-size: 12px;
        input {
          padding-left: 10px !important;
        }
      }
    }
  }

  .drinks-row-block2 {
    img {
      height: 63px !important;
    }
  }

  .drinks-row {
    .block-1 {
      width: 86% !important;
    }
    .block-2 {
      width: 14% !important;
    }
  }

  .output1-row-block {
    padding: 0 !important;
    .scaleable, .grinder {
      font-size: 21px !important;
    }
  }

  .grinder-row-block {
    padding: 0 !important;
    .water, .pressure {
      .input {
        input {
          font-size: 15px !important;
        }
        span {
          font-size: 15px !important;
        }
      }
    }
  }

  .milk-steamer-row-block {
    padding: 0 !important;
    .water, .pressure {
      .input {
        input {
          font-size: 15px !important;
        }
        span {
          font-size: 15px !important;
        }
      }
    }
  }

  .parameters-row-block {
    padding: 0 !important;
    .label {
      font-size: 20px !important;
    }
  }
}

@media (min-width: 300px) and (max-width: 760px) {

  .drinks-row-block1 {
    padding: 0 !important;
  }

  .output1-row-block {
    padding: 0 !important;
    .grinder {
      .type {
        float: left;
      }
    }
    .p-0 {
      padding: 0 !important;
    }
    .content {
      .minimum {
        margin: 0 !important;
      }
      .start-time {
        margin: 0 !important;
      }
      .maximum {
        margin: 0 !important;
      }
      .run-time {
        margin: 0 !important;
      }
    }
  }

  .grinder-row-block {
    padding: 0 !important;
  }

  .milk-steamer-row-block {
    padding: 0 !important;
  }

  .parameters-row-block {
    padding: 0 !important;
  }

}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0 !important;
}

input[type='number'] {
  -moz-appearance: textfield;
}

.header {
  .toggle-btn {
    background: #6F7E8D;
    padding-left: 6px;
    padding-right: 7px;
    color: white;
    font-weight: bolder;
    border: 2px solid #868C8D;
    border-radius: 8px;
    cursor: pointer;
    outline: none !important;
    padding-top: 2px;
    font-size: 18px;
    -webkit-text-stroke: 2px #6F7E8D;
  }

}

.output {
  padding-top: 8px;
  padding-bottom: 8px;
}

.output-collapse {
  overflow: hidden;
  height: auto;
  max-height: 0 !important;
  -webkit-transition: max-height 1s ease;
  transition: max-height 1s ease;
  transition-delay: -.2s;
}

.icon-collapse {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &:before {
    content: '\F067'
  }
}

.icon-expand {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &:before {
    content: '\F068'
  }
}

.output-expand {
  height: auto;
  max-height: 1400px !important;
  -webkit-transition: max-height .8s ease;
  transition: max-height 1s;
  @include fadeInDown($visibility: visible, $fill: none, $duration: 1s);
}

@mixin table {
  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border: 1px solid #ddd;
    color: #45515E;
    thead {
      color: #FEFEFD;
      background-color: #6F7C8C;
      width: calc(100% - 0em);
    }
    tr {
      border-bottom: 1px solid #8393a0;
    }
    th {
      font-weight: 400 !important;
    }
    th, td {
      border: none;
      text-align: left;
      padding: 6px 8px;
    }
  }
}

@mixin plus-button {
  border: 2px solid #71828f;
  color: #71828f;
  border-radius: 100%;
  outline: none !important;
  background-color: #d6d9de;
  -webkit-text-stroke: 2px #d6d9de;
}

@mixin modal {
  height: 300px;
  background-color: #D1D2D6;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  border: 1px solid #8393a0;
  border-right: 2px solid #8393a0;
  position: absolute;
  z-index: 1;
  overflow-x: auto;
  overflow-y: auto;
}

.editor {
  @media (min-width: 767px) {
    overflow-y: auto;
    overflow-x: hidden;
  }
  @media (max-width: 767px) and (max-height:1000px) {
    height: auto !important;
  }
  .add-output-true {
    margin-top: 120px;
  }

  .add-output-false {
    margin-top: 0;
    transition: margin-top 0.5s;
  }

  .output-adding {
    padding-top: 10px;
    button {
      @include plus-button;
      margin-top: 5px;
      margin-bottom: 5px;
      color: #71828f;
      width: 28px;
      height: 28px;
      font-size: 18px !important;
      padding-top: 2px;
      padding-left: 5px;
    }
    .add-output-button {
      padding-top: 4px;
      margin-left: -6%;
      .add-output-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        .button-text {
          flex-grow: 0;
          button {
            @include plus-button;
            width: 38px;
            height: 38px;
            padding: 0;
            padding-top: 2px;
            font-size: 21px !important;
          }
          .text {
            padding: 0 8PX;
            font-size: 12px;
            color: #71828f;
          }
        }
        .divider {
          flex-grow: 1;
          height: 2px;
          background-color: rgb(128, 145, 157);
        }
      }
    }
    .modal-open-true {
      @include modal;
      width: 115%;
      bottom: 100%;
      left: -9%;
      @include bounceIn($duration: .5s,
      $delay: 0s,
      $function: ease,
      $fill: both);
      @include table;
    }
    .modal-open-false {
      @include modal;
      visibility: hidden;
      height: 200px !important;
      width: 115%;
      bottom: 100%;
      left: -9%;
      @include bounceOut($duration: 0.5s,
      $delay: 0s,
      $function: ease,
      $fill: both);
      transition: visibility 0.5s, height 0.5s ease;
      @include table;
    }
  }
}

@media (max-width: 767px) {
  .output {
    .mobile-output {
      .fa-info-circle {
        margin-left: 4px !important;
      }
      font-size: 22px !important;
      &:after {
        display: table;
        content: '';
        clear: both;
      }
    }
    .mobile-output-delete {
      &:after {
        display: table;
        content: '';
        clear: both;
      }
    }
    .mobile-output-type {
      font-size: 18px !important;
    }
  }
}

@media (max-width: 767px) {
  .editor {
    .add-output-true {
      margin-top: 0 !important;
    }
    .add-output-false {
      margin-top: 0 !important;
    }
    .output-adding {
      .modal-open-true {
        width: 100% !important;
        bottom: 103% !important;
        left: 0 !important;
        right: 0 !important;
      }
      .modal-open-false {
        width: 100% !important;
        bottom: 103% !important;
        left: 0 !important;
        right: 0 !important;
      }
    }
  }
}

@media (max-width: 767px) and (max-height: 1000px){
  .editor {
    .all-outputs {
      min-height: 100% !important;
      max-height: 100% !important;
    }
  }
}

@media (min-width: 768px) and (max-width: 1050px) {
  .editor {
    .output-adding {
      .modal-open-true {
        height: 285px !important;
        width: 98% !important;
        left: 1% !important;
        bottom: 90% !important;
      }
      .modal-open-false {
        width: 98% !important;
        left: 1% !important;
        bottom: 90% !important;
      }
    }
  }
}

@media (max-width: 1150px) {
  .editor {
    .add-output-button {
      padding-top: 10px !important;
      margin-left: -22px !important;
    }
  }
}

@media (min-width: 1400px) {
  .header {
    font-size: 23px !important;
  }
  .drinks-row {
    .block-1 {
      .drinks-row-block1 {
        .Select {
          .Select-control {
            height: 40px !important;
          }
        }
        .Select-placeholder {
          padding-top: 3px !important;
        }
        .col-md-custom {
          div {
            padding-top: 7px;
            padding-bottom: 7px;
            span {
              font-size: 15px;
            }
          }
        }
        button {
          font-size: 14px;
          padding: 12px;
        }
      }
    }
  }
  .all-outputs {
    overflow: auto;
    .output1-row {
      .output1-row-block {
        .title {
          font-size: 15px !important;
        }
      }
    }

    .grinder-row {
      .grinder-row-block {
        .title {
          padding-bottom: 6px !important;
        }
        .input {
          padding: 3px;
          input {
            font-size: 16px;
          }
          span {
            font-size: 16px;
          }
        }
        .Select {
          .Select-control {
            height: 40px !important;
          }
        }
        .Select-placeholder {
          padding-top: 3px !important;
        }
      }
    }

    .milk-steamer-row {
      .milk-steamer-row-block {
        .title {
          padding-bottom: 6px !important;
          font-size: 14px !important;
        }
        .input {
          padding: 3px;
          input {
            font-size: 16px;
          }
          span {
            font-size: 16px;
          }
        }
        .Select {
          .Select-control {
            height: 40px !important;
          }
        }
        .Select-placeholder {
          padding-top: 3px !important;
        }
      }
    }
  }
}

/*
.mytextdiv {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.mytexttitle {
  flex-grow: 0;
}

.divider {
  flex-grow: 1;
  height: 2px;
  background-color: #9f9f9f;
}*/



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/editor/editor.scss